import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';

import { InformationEffectsModule } from '@core/store/effects';
import { reducers } from '@core/store/reducers';
import * as fromServices from '@core/store/services';

export * from '@core/store/reducers';
export * from '@core/store/effects';
export * from '@core/store/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('information', reducers), InformationEffectsModule],
  providers: [...fromServices.services]
})
export class InformationStoreModule {}
